import { B2B_ADDRESSES_PATH, B2B_UPDATE_ADDRESSES_PATH, B2B_ACCOUNT_PATH, } from '../../constants/links';
import { apiB2B } from '../axios-client';
export const b2bAddressesApi = {
    addNewAddress: (address) => apiB2B.post(B2B_UPDATE_ADDRESSES_PATH, {
        addressRequest: {
            address: [address],
        },
    }),
    deleteAddress: ({ addrIdentifier, userId: ownerUserId, }) => apiB2B.delete(`${B2B_ADDRESSES_PATH}/${addrIdentifier}`, {
        params: {
            ownerUserId,
        },
    }),
    editAddress: (...addresses) => apiB2B
        .put(B2B_UPDATE_ADDRESSES_PATH, {
        addressRequest: {
            address: addresses,
        },
    })
        .then(({ data }) => data),
    ogHmac: ({ customerSVOCId, host = '', }) => {
        if (!customerSVOCId) {
            return Promise.reject(new Error('Cannot call ogHmac without custId'));
        }
        const ogHmacUrl = new URL(`${B2B_ACCOUNT_PATH}/${customerSVOCId}/ogHmac`, host);
        return apiB2B.get(ogHmacUrl.href, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
    },
};
